import { useTranslation } from "@l2r-front/l2r-i18n"
import { useTheme } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { getRoadsideLegendConfig } from "../../utils/getRoadsideConfig"

export function useRoadsideLegend() {

    const { t } = useTranslation(I18N_NAMESPACE)
    const theme = useTheme()

    return [
        {
            layerName: "roadside",
            legendData: getRoadsideLegendConfig(t, theme),
            title: t(I18N_NAMESPACE, "containers.roadside.legend.title"),
        },
    ]
}